var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.3125 3.8125C35.0625 6.4375 35.0625 12.0625 35.0625 12.0625C35.0625 12.0625 35.0625 17.625 34.3125 20.3125C33.9375 21.8125 32.75 22.9375 31.3125 23.3125C28.625 24 18 24 18 24C18 24 7.3125 24 4.625 23.3125C3.1875 22.9375 2 21.8125 1.625 20.3125C0.875 17.625 0.875 12.0625 0.875 12.0625C0.875 12.0625 0.875 6.4375 1.625 3.8125C2 2.3125 3.1875 1.125 4.625 0.75C7.3125 0 18 0 18 0C18 0 28.625 0 31.3125 0.75C32.75 1.125 33.9375 2.3125 34.3125 3.8125ZM14.5 17.125L23.375 12.0625L14.5 7V17.125Z","fill":"white"}));
}

Youtube.defaultProps = {"width":"36","height":"24","viewBox":"0 0 36 24","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
